import { Stack } from '@mui/material';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { Card } from '@occc-app/design-system';

import { ReceiverConfigurationForm } from '../award-configuration/receiver-configuration-form.component';
import { SenderConfigurationForm } from '../award-configuration/sender-configuration-form.component';
import { QualifyingEventConfigurationForm } from '../qualifying-event-configuration/qualifying-event-configuration-form.component';

export const ConfigureTabForm = () => {
  return (
    <Stack component={Card} p={3} spacing={5} mb={0}>
      <SenderConfigurationForm />
      <ReceiverConfigurationForm />
      <QualifyingEventConfigurationForm />
    </Stack>
  );
};
